/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorSecondNativeArticle from 'base/components/labrador/SecondNativeArticle';

export const DynamicLabradorSecondNativeArticle: typeof LabradorSecondNativeArticle = (props) => {
    return <ErrorBoundary><LabradorSecondNativeArticle {...props} /></ErrorBoundary>;
}
export type DynamicLabradorSecondNativeArticleProps = PropsFromComponent<typeof LabradorSecondNativeArticle>;
